<template lang="pug">

  OverlaysPreview(:video="video")
    div(slot="videoSlot")
      video-player.videoPlayer(
          ref="videoPlayer",
          :options="playerOptions",
          @error="error = true",
          @ready="playerReadied"
          @ended="donePlayingClip"
          @statechanged="playerStateChanged($event)"
          :playsinline="true",
          :controls="false"
          v-if="video && playerOptions.sources[0].src != undefined"
      )
    
</template>

<script>
import urlFormat from "@/utils/urlFormat";
import VueVideoPlayer from "vue-video-player";
import { EventBus } from "@/event-bus";
import OverlaysPreview from "@/components/create/OverlaysPreview";
export default {
  name: "OverlayPlayer",
  data() {
    return {
      isPlaying: false,

      initialPlayerOptions: {
        fluid: true,
        autoplay: false,
        preload: true,
        loop: false,
        token: null,
        controls: false,
        loadingSpinner: false,
        bigPlayButton: false,
        language: "de",
        sources: [
          {
            src: undefined,
            type: "application/x-mpegURL",
          },
        ],
        html5: {
          nativeAudioTracks: false,
          nativeVideoTracks: false,
          hls: {
            overrideNative: true,
          },
        },
        hls: {
          overrideNative: true,
        },
      },
      error: false,
    };
  },
  components: {
    OverlaysPreview,
  },
  props: ["video"],
  mounted() {
    EventBus.$on("play", (data) => {
      if (data.id === this.video.id) {
        this.playClip();
      }
    });
    EventBus.$on("resetPlay", (data) => {
      if (data.id === this.video.id) {
        this.playClip(true);
      }
    });
    EventBus.$on("pause", (data) => {
      if (!data) {
        this.pauseClip();
      } else if (data.id === this.video.id) {
        this.pauseClip();
      }
    });
  },
  computed: {
    playerOptions() {
      let sources = [];
      if (this.video.id == "intro" || this.video.id == "outro") {
        sources = [
          {
            src: this.video.url,
          },
        ];
        return { ...this.initialPlayerOptions, sources };
      } else {
        const source = VueVideoPlayer.videojs.browser.IS_ANY_SAFARI
          ? {
              src: this.getVideoDownloadUrl(
                this.video.id,
                this.video.token,
                "_16x9_1920x1080p_24Hz_6Mbps",
                "mp4"
              ),

              type: "video/mp4",
            }
          : {
              src: this.getVideoStreamUrl(this.video.id, this.video.token),
              type: "application/x-mpegURL",
            };
        sources = [source];
        return {
          ...this.initialPlayerOptions,
          sources,
          poster: this.getThumbnailUrl(
            this.video.id,
            this.video.token,
            this.video.element
          ),
        };
      }
    },
  },
  methods: {
    ...urlFormat,
    playClip(fromStart) {
      const myPlayer = this.$refs.videoPlayer.player;
      if (fromStart) {
        myPlayer.currentTime(0);
      }
      myPlayer.play();
      this.isPlaying = true;
    },

    pauseClip() {
      const myPlayer = this.$refs.videoPlayer.player;

      myPlayer.pause();
      this.isPlaying = false;
    },
    donePlayingClip() {
      this.$emit("donePlaying", this.video);
    },
    playerStateChanged(playerCurrentState) {
      if (playerCurrentState.timeupdate) {
        this.$emit("timeUpdate", {
          time: playerCurrentState.timeupdate,
          clipId: this.video.id,
        });
      }
    },
    playerReadied(player) {
      const token = this.video.token;
      if (player.tech_.hls) {
        player.tech_.hls.xhr.beforeRequest = function (options) {
          options.uri = `${options.uri}${token}`;
          return options;
        };
      }
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'

.videoPlayer
  box-shadow: none
  border-radius: 10px
  overflow: visible
  width: 100%
  height: 100%
  min-height: 100%
  .video-js
      min-height: 100%
  // background: $primary
</style>
